import React from 'react'
import { useCity, SelectedCity } from '../context/CityContext'
import { useGetCitiesQuery } from '../components/CityBar/__generated__/CityBar'
import { useCompletePointGeoMutation } from '../components/providers/MapProvider/__generated__/points'

export function useCityGeolocation() {
    const { setSelectedCity } = useCity()
    const { data: citiesData } = useGetCitiesQuery()
    const [completePointGeo] = useCompletePointGeoMutation()

    const locate = React.useCallback(async (): Promise<SelectedCity | null> => {
        if (typeof navigator === 'undefined' || !('geolocation' in navigator)) {
            return null
        }

        const position = await new Promise<GeolocationPosition>(
            (resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: false,
                    timeout: 10000,
                    maximumAge: 60000
                })
            }
        )

        const { latitude, longitude } = position.coords
        const result = await completePointGeo({
            variables: { input: { latitude, longitude, sort: 0 } }
        })
        const point = result.data?.fillPointGeo
        if (!point) return null

        const cities = citiesData?.cities ?? []
        const city =
            cities.find((c) => c.id === point.cityId) ??
            cities.find((c) => c.name === point.cityName)

        if (!city) return null

        const selected: SelectedCity = {
            id: city.id,
            name: city.name,
            latitude: city.latitude,
            longitude: city.longitude,
            countryId: city.countryId,
            countryName: point.countryName
        }
        setSelectedCity(selected)
        return selected
    }, [completePointGeo, citiesData, setSelectedCity])

    return locate
}
